import logger from "./logger";
import { parseHorseFormattedName } from "./parse-horse-name";

export const transformRaceData = (
  raceData,
  options = { includeConfidence: false },
  earlyPredictionsData = null,
) => {
  // Handle both leaderboard and historical data structures
  const firstFourData =
    raceData?.firstFourData || raceData?.predictionData?.firstFourData;

  // Get early predictions data for this specific race
  const raceKey = `${raceData?.track?.replace(/\s+/g, "-")}-${raceData?.race}-${raceData?.date}`;
  const earlyPredictionsForRace =
    earlyPredictionsData?.[raceKey]?.firstFourData || [];

  // Debug logging for early predictions
  // logger.log("=== Transform Data Debug ===");
  // logger.log("Race Key:", raceKey);
  // logger.log("Early Predictions Data Available:", !!earlyPredictionsData);
  // logger.log("Early Predictions for this race:", earlyPredictionsForRace);
  // logger.log("=== End Transform Data Debug ===");

  if (!firstFourData || !Array.isArray(firstFourData)) {
    return [];
  }

  return firstFourData.map((horse, index) => {
    // Defensive parse: a missing "<number>. " prefix must not drop the horse
    // name into the number slot (see parse-horse-name.js).
    const { number, name } = parseHorseFormattedName(horse);
    const confidence = getConfidenceLevel(horse.currentPrice);

    // Try to find matching horse in early predictions to get its selectionId
    const earlyPredictionHorse = Array.isArray(earlyPredictionsForRace)
      ? earlyPredictionsForRace.find((early) => {
          if (!early) return false;
          const numberMatch = horse.number === early.number;
          const nameMatch =
            horse.name?.toLowerCase().trim() ===
            early.name?.toLowerCase().trim();
          return numberMatch && nameMatch;
        })
      : null;

    // Debug log for matching
    // logger.log("Horse matching debug:", {
    //   horseName: name,
    //   horseNumber: number,
    //   foundMatch: !!earlyPredictionHorse
    // });

    const baseTransform = {
      rank: index + 1,
      name: name,
      number: number,
      silks: horse.silks,
      horseId: horse.horseId, // Preserve horseId from original data
      tipType: confidence,
      currentPrice: horse.currentPrice,
      selectionId: horse.selectionId || earlyPredictionHorse?.selectionId,
      isEarlyPrediction: !!earlyPredictionHorse,
      effectivePrice: horse.effectivePrice,
      jockey:
        typeof horse.jockey === "object"
          ? horse.jockey?.fullName || horse.jockey?.name || null
          : horse.jockey,
      trainer:
        typeof horse.trainer === "object"
          ? horse.trainer?.fullName || horse.trainer?.name || null
          : horse.trainer,
      weight: horse.weight,
      form: horse.form,
      prizeMoney: horse.prizeMoney,
      sex: horse.sex,
      effectivePriceConfidence: horse.effectivePriceConfidence,
      isActive: horse.isActive,
      lastPriceTraded: horse.lastPriceTraded,
    };

    if (options.includeConfidence) {
      return {
        ...baseTransform,
        confidence: getConfidenceLevel(horse.currentPrice),
        analysis:
          raceData.decisionExplanation +
          " " +
          (raceData.favouriteBeatable?.weakness || ""),
      };
    }

    // Add podium results if available
    if (raceData.podium) {
      return {
        ...baseTransform,
        result: raceData.podium[index] || "UPL",
      };
    }

    return baseTransform;
  });
};

const getConfidenceLevel = (price) => {
  if (price > 10) {
    return "high";
  } else if (price < 10 && price > 2) {
    return "medium";
  } else {
    return "low";
  }
};
